module.exports = __webpack_public_path__ + "src/img/rightwardgrey.e6963a96.svg";